import React from 'react';
import { Tabs } from 'antd';
import AuditTable from '../AuditLogs/auditTable';
import { useNavigate, useLocation } from 'react-router-dom';

const AuditLogs = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Define route <-> tab key mapping
  const pathToKeyMap = {
    '/app/audit_logs': 'audit_logs',
  };

  const keyToPathMap = {
    'audit_logs': '/app/audit_logs',
  };

  // Get current active tab based on path
  const activeTab = pathToKeyMap[location.pathname] || 'audit_logs';

  const onChange = (key) => {
    navigate(keyToPathMap[key]);
  };

  const customTabBar = (props, DefaultTabBar) => (
    <div className="TabListTopBox">
      <DefaultTabBar {...props} />
    </div>
  );

  const items = [
    {
      key: 'audit_logs',
      label: 'Audit Logs',
      children: <AuditTable />,
    },
  ];

  return (
    <div className='TopTablesTabsBox TabNavigation'>
      <Tabs
        activeKey={activeTab}
        onChange={onChange}
        renderTabBar={customTabBar}
        className='TopTablesTabs'
        items={items}
      />
    </div>
  );
};

export default AuditLogs;
